import { useEffect, useRef } from 'react'

// Attach the returned ref to a sentinel element at the end of a scrollable list;
// `onLoadMore` fires when it scrolls into view. `enabled` gates observation
// (typically hasMore && !loading). `rootMargin` pre-triggers before the sentinel
// is fully visible for a seamless feel.
export default function useInfiniteScroll(
  onLoadMore,
  { enabled = true, root = null, rootMargin = '200px' } = {}
) {
  const sentinelRef = useRef(null)
  const cbRef = useRef(onLoadMore)
  cbRef.current = onLoadMore

  useEffect(() => {
    const node = sentinelRef.current
    if (!node || !enabled) return undefined

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) cbRef.current?.()
      },
      { root, rootMargin }
    )
    observer.observe(node)
    return () => observer.disconnect()
  }, [enabled, root, rootMargin])

  return sentinelRef
}
